import React from "react";
import "./EditorLeftMenuSubjectControls.css";
import SubjectControlsMenu from "./SubjectControlsMenu";
import SubjectExtraTools from "./SubjectExtraTools";
import Rotate from "../../../tools/object/rotate/Editor/Rotate";
import Flip from "../../../tools/object/flip/Editor/Flip";
import Shadow from "../../../tools/object/shadow/Editor/Shadow";
import Outline from "../../../tools/object/outline/Editor/Outline";
import Watermark from "../../../tools/watermark/Editor/Watermark";
import { IS_APP_V1 } from "../../../../config/app/appVersion";

const EditorLeftMenuSubjectControls = ({
  onAlign,
  onRestoreBackgroundRemoved,
  removeBackgroundActive,
  onRemoveBackgroundChange,
  shadowDefaultExpanded = false,
  outlineDefaultExpanded = false,
  watermarkDefaultExpanded = false,
}) => {
  const handleToolToggle = (toolName, isEnabled) => {
    // When onRemoveBackgroundChange is wired, it owns the full ON/OFF + API flow.
    if (typeof onRemoveBackgroundChange === "function") return;
    if (toolName === "removeBackground" && isEnabled && onRestoreBackgroundRemoved) {
      onRestoreBackgroundRemoved();
    }
  };

  return (
    <div className="editor-left-menu-subject-controls-wrapper">
      <SubjectControlsMenu
        onAlign={onAlign}
        beforeAlign={
          <SubjectExtraTools
            onToolToggle={handleToolToggle}
            removeBackgroundActive={removeBackgroundActive}
            onRemoveBackgroundChange={onRemoveBackgroundChange}
            hideReflection={IS_APP_V1}
          />
        }
      />
      <div className="editor-left-menu-object-tools">
        <Rotate />
        <Flip />
        <Shadow defaultExpanded={shadowDefaultExpanded} />
        <Outline defaultExpanded={outlineDefaultExpanded} />
        <Watermark defaultExpanded={watermarkDefaultExpanded} />
      </div>
    </div>
  );
};

export default EditorLeftMenuSubjectControls;
